var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonLink } from '@marketing/components/global/CTA/Button';
import Heading from '@marketing/components/global/typography/Heading';
import Step from './Step';
function HowItWorks(_a) {
    var content = _a.content;
    var steps = content.steps, ctaUrl = content.ctaUrl;
    return (_jsxs("div", __assign({ className: "flex flex-col items-center gap-xl-m px-2xs-gutter py-sm-gutter md:px-xl-gutter md:py-lg-gutter w-full bg-surface-white" }, { children: [_jsx(Heading, __assign({ size: "md" }, { children: "How It Works" })), _jsx("div", __assign({ className: "flex flex-col gap-xl-m md:gap-lg-gutter px-2xs-gutter py-xs-gutter md:px-lg-gutter md:py-md-gutter w-full md:max-w-2xl bg-surface-beige rounded-md md:rounded-lg" }, { children: steps.map(function (step, index) { return (_jsx(Step, __assign({}, step), index)); }) })), _jsx(ButtonLink, __assign({ href: ctaUrl, size: "small", use: "secondary" }, { children: "Get Started" }))] })));
}
export default HowItWorks;
